module.exports = __webpack_public_path__ + "static/media/csm-phone.bdd7e4ef.svg";